import { getValueFromPath } from 'helpers/ObjectUtils';

if (!global.MA || !global.MA.Config || !global.dispatchers) {
    throw new Error(
        `Dispatchers not found.
        Use \`config.template.js\` to override key/value in datastore https://console.cloud.google.com/datastore/entities/query.
        Use \`make init-front-config\` to create your own config locally`,
    );
}

/**
 * Check if a feature is enabled for a feature key
 * @requires MA.Config
 * @return {boolean}
 */
export default function checkDispatcher(key, type = 'ab') {
    return Boolean(getValueFromPath(global, `dispatchers.${type}_dispatcher.${key}`));
}
